export default function Footer() {
  return (
    <footer className="bg-dark-900/95 text-dark-300 border-t border-dark-700 py-6 sm:py-8 text-center mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-sm sm:text-base">
          <b>© The Dingocoin Project 2021 - 2026</b>
        </span>
      </div>
    </footer>
  );
}